import * as React from "react";

import Section from "./Section";
import ThemeLogoUploadSetting from "./ThemeLogoUploadSetting";

const ThemeLogoSection: React.ReactFCWithChildren = () => (
  <Section title="Logo">
    <ThemeLogoUploadSetting
      type="light"
      description="Customise the logo to be shown on dark backgrounds"
    />

    <ThemeLogoUploadSetting
      type="dark"
      description="Customise the logo to be shown on light backgrounds"
    />
  </Section>
);

export default ThemeLogoSection;
